module.exports = __webpack_public_path__ + "static/media/dtrans_p02ru.b817bf58.pdf";